export enum EntityStatsType {
  oneUser = 'oneUser',
  org = 'org',
  orgAdmin = 'orgAdmin',
  notOrgAdmin = 'notOrgAdmin',
}
